<template>
  <UnitList
    :units="unitList"
    :fields="fields"
    sortBy="dateConfigPull"
    @selectUnit="selectUnit"
  />
</template>

<script>
import api from "@/api";
import UnitList from "@/components/UnitList";

export default {
  name: "UnitsByGroup",
  props: {},
  data() {
    return {
      unitList: [],
      fields: [
        { key: "friendlyName", label: "Unit Name", sortable: true },
        { key: "unitId", label: "Unit ID Number", sortable: false },
        { key: "createdAt", label: "Date Created", sortable: true },
        {
          key: "dateConfigPull",
          label: "Device recieved config",
          sortable: true,
        },
        { key: "dateHello", label: "Last Online", sortable: true },
        { key: "version", label: "GoLive Version", sortable: false },
      ],
    };
  },
  methods: {
    async loadUnits() {
      let result = await api.units.getByConfigPull();

      let { error, message, results } = result;

      if (error) {
        console.error(message);
        return;
      }

      this.unitList = results.units;
    },

    selectUnit(id) {
      this.$emit("selectUnit", id);
    },
  },

  components: {
    UnitList,
  },

  beforeMount() {
    this.loadUnits();
  },
};
</script>
